import Component from '../core/Component'
import { EVENTS } from '../core/Events'
import EventBus from '../core/EventBus'


const pushToDataLayerOnClick = (clickEvent, data) => {
    if (window['google_tag_manager']) {
        const targetUrl = clickEvent.target.href;
        const isSamePage = targetUrl.startsWith(`${window.location.origin}${window.location.pathname}`)

        //pokud vede url jinam, tak preventDefault a pockat na odbaveni eventu... pak redirect
        if (!isSamePage) {
            clickEvent.preventDefault();
        }

        window.dataLayer?.push({
            ...data,
            'eventCallback' : function() {
                if (!isSamePage) {
                    window.location = targetUrl
                }
            },
            'eventTimeout' : 2000
        });
      }
}

const ACTIONS = {
    'immediate': ({ data }) => {
        window.dataLayer?.push(data)
    },
    'click': ({ element, data }) => {
        element.addEventListener('click', (event) => {
            pushToDataLayerOnClick(event, data)
        })
    },
    'clickSavingsCalculatorCta': ({ element }) => {
        element.addEventListener('click', (event) => {
            pushToDataLayerOnClick(event, {
                event: 'calculate_savings',
                savingCalculation: {
                    'button': element.innerText,
                    'deposit': parseInt(document.querySelector('[data-datalayer-deposit]').value.replace(/\s/g, '')),
                    'period': parseInt(document.querySelector('[data-datalayer-period]').value.replace(/\s/g, ''))
                }
            })
        })
    },
    'clickLoanCalculatorCta': ({ element, data }) => {
        element.addEventListener('click', (event) => {
            pushToDataLayerOnClick(event, {
                event: 'calculate_loan',
                loanCalculation: {
                    'button': element.innerText,
                    'deposit': parseInt(document.querySelector('[data-datalayer-deposit]').value.replace(/\s/g, '')),
                    'period': parseInt(document.querySelector('[data-datalayer-period]').value.replace(/\s/g, ''))
                }
            })
        })

    },
}

export default class DataLayer extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.items = []
    }

    prepare() {
        this.registerElements()
        EventBus.on(EVENTS.DOM_CHANGE, this.handleDomChange)
    }

    destroy() {
        EventBus.off(EVENTS.DOM_CHANGE, this.handleDomChange)
    }

    handleDomChange = () => {
        this.registerElements()
    }

    registerElements() {
        const elements = [...document.querySelectorAll('[data-datalayer]')]
        elements.forEach(element => {
            if (this.items.find(item => item.element === element)) {
                // element already registered
                return
            }

            const { action = null, data = null } = JSON.parse(element.dataset.datalayer)
            if (!action) {
                console.error(`Missing 'action' in [data-datalayer]`)
                return
            }

            this.items.push({
                element,
                action,
                data,
                watched: false
            })
        })

        this.watchElements()
    }

    watchElements() {
        this.items.filter(item => !item.watched).forEach(item => {
            const action = ACTIONS[item.action]
            if (!action) {
                console.error(`Action ${action} not implemented`)
                return
            }
            action(item)
            item.watched = true
        })
    }
}